import { render, staticRenderFns } from "./RowDetails.vue?vue&type=template&id=10008ab9&"
import script from "./RowDetails.vue?vue&type=script&lang=js&"
export * from "./RowDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports